import React from "react";
import ReactDOM from "react-dom/client";
import "@basket/ui/styles.css";
import "./web.css";
import { AppV2 } from "./app-v2.js";
import { isBasketProductRoute, MarketingSite } from "./marketing-site.js";
import "./marketing-site.css";
import { registerBasketServiceWorker } from "./register-service-worker.js";

registerBasketServiceWorker();

const content = isBasketProductRoute(window.location.pathname)
  ? <AppV2 />
  : <MarketingSite />;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {content}
  </React.StrictMode>,
);
